import * as angular from 'angular';
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import DefectClassificationServiceName, {DefectClassificationService} from "../../services/defects/defectClassification.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import {Enums} from "../../shared/config/constant.module";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as _ from "lodash";
import template from './addDefectType.tpl.html';

let requires = [UIUtilityServiceName, DefectClassificationServiceName, NotifyServiceName, LoaderServiceName,
  NewGuidServiceName, DefectTypeServiceName];

interface AddDefectTypeController {
  fileNameChanged(): void;
  cancel(): void;
  form: angular.IFormController;
  wareClasses: apsViewModels.WareClassSelection[];
  wareClassesArray: DefectWareClass[];
  unqualificationScopes: EnumOption[];
  displayWareClasses: boolean;
  defectTypeDetails: apsCommands.AddDefectType;
  defectClassifications: apsViewModels.DefectClassification[];
  severities: any;
  submitDefectType(): void;
}

interface DefectWareClass {
  id: string;
  wareClass: apsViewModels.WareClassSelection;
  severity: apsEnums.Severity;
}

export function openAddDefectType($modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddDefectTypeCtrl as vm'
  }).result;
}

export default angular.module('aps.controller.addDefectType', requires)
  .controller('AddDefectTypeCtrl', addDefectTypeCtrl)
  .name;

function addDefectTypeCtrl(
  $modalInstance: mm.foundation.modalInstance,
  notifyService: NotifyService,
  loaderService: LoaderService,
  newGuidService: NewGuidService,
  defectTypeService: DefectTypeService,
  defectClassificationService: DefectClassificationService,
  defectTypeDetailsViewModelService,
  uiUtilityService: UIUtilityService
): AddDefectTypeController {
  var vm = this as AddDefectTypeController;
  var defectTypeImageFileIdentifier = 'defectTypeImage';
  var defectTypeImageSrcIdentifier = 'defectTypeImageSrc';
  var fileReader = new FileReader();

  vm.defectTypeDetails = {
    wareClasses: [],
    defectImage: '',
    hotEndUnqualificationScope: apsEnums.UnqualificationScope.None,
    coldEndUnqualificationScope: apsEnums.UnqualificationScope.None,
  } as apsCommands.AddDefectType;

  vm.displayWareClasses = false;

  vm.severities = _.toArray(Enums.SEVERITY);
  vm.unqualificationScopes = uiUtilityService.getListOptionsFromEnum(apsEnums.UnqualificationScope);
  vm.wareClassesArray = [];

  var loadWareClasses = function() {

    if ((vm.wareClasses || '') !== '') {
      _.each(vm.wareClasses, function (wCItem) {

        vm.wareClassesArray.push({
          id: '',
          wareClass: wCItem,
          severity: null
        });

      });
    }
  };

  var fillWareClasses = function() {

    _.each(vm.wareClassesArray, function(defectWareClass: any){

      var itemFound = false;
      var severity = vm.displayWareClasses ? defectWareClass.severity : '';

      var wc = _.find(vm.defectTypeDetails.wareClasses, function (item: any) {
        return item.wareClassId === defectWareClass.wareClass.id;
      });

      if ((wc || '') !== '') {
        itemFound = true;
        wc.severity = severity;
      }

      if (itemFound === false) {
        vm.defectTypeDetails.wareClasses.push({
          id: null,
          wareClassId: defectWareClass.wareClass.id,
          defectTypeId: vm.defectTypeDetails.id,
          severity: severity
        });
      }
    });
  };

  var postDefectType = function() {
    var promise = defectTypeService.addDefectType(vm.defectTypeDetails)
      .then(function () {
        $modalInstance.close(vm.defectTypeDetails);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  defectTypeDetailsViewModelService.apply(vm.defectTypeDetails);

  newGuidService.getNewGuid('defectType').then(function(data) {
    vm.defectTypeDetails.id = data;
  });

  defectClassificationService.getDefectClassifications().then(function(defectClassifications){
    vm.defectClassifications = defectClassifications;
  });

  defectTypeService.getDefectTypeWareClasses().then(function(wareClasses){
    vm.wareClasses = wareClasses;
    loadWareClasses();
  });

  fileReader.onload = function (event: any) {
    if ((event.target.result || '') !== '') {
      var uri = event.target.result;
      vm.defectTypeDetails.defectImage = uri;
      var defectTypeImageSrc = <any>angular.element('#' + defectTypeImageSrcIdentifier);
      if ((defectTypeImageSrc || '') !== '') {
        if ((defectTypeImageSrc[0] || '') !== '') {
          defectTypeImageSrc[0].src = uri;
        }
      }
    }
  };

  vm.fileNameChanged = function() {
    var defectTypeImageFile = <any>angular.element('#' + defectTypeImageFileIdentifier);
    if ((defectTypeImageFile || '') !== '') {
      if ((defectTypeImageFile[0] || '') !== '') {
        if ((defectTypeImageFile[0].files[0] || '') !== '') {
          fileReader.readAsDataURL(defectTypeImageFile[0].files[0]);
        }
      }
    }
  };

  vm.submitDefectType = function() {
    if (vm.form.$invalid) {
      return;
    }

    if (vm.displayWareClasses === true) {
      fillWareClasses();
    }
    postDefectType();
  };

  vm.cancel = function() {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectTypeAdmin/addDefectType.controller.ts